<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>地图组件技能库</h2>
      <p>展示高德地图点聚合、状态筛选、自定义聚合样式和点位详情能力</p>
    </div>

    <el-row :gutter="20">
      <el-col :span="24">
        <CodeCard
          title="高德地图点聚合示例"
          description="支持海量点位聚合、状态过滤、主题切换、定位和点位详情查看"
          :codeContent="pointClusterCode"
        >
          <PointCluster />
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import PointCluster from '@/components/map/pointCluster.vue'

export default {
  name: 'PcMapPointCluster',
  components: {
    CodeCard,
    PointCluster
  },
  data() {
    return {
      pointClusterCode: `<template>
  <PointCluster />
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  async mounted() {
    const AMap = await AMapLoader.load({
      key: 'YOUR_AMAP_KEY',
      version: '2.0',
      plugins: ['AMap.Scale', 'AMap.ToolBar', 'AMap.MarkerClusterer']
    })

    this.map = new AMap.Map(this.$refs.mapContainer, {
      zoom: 11,
      center: [116.397428, 39.90923],
      resizeEnable: true
    })

    this.clusterer = new AMap.MarkerClusterer(this.map, markers, {
      gridSize: 80,
      minClusterSize: 5,
      averageCenter: true,
      renderClusterMarker: this.renderClusterMarker
    })
  }
}
<\/script>`
    }
  }
}
</script>

<style scoped>
.skill-page {
  /* 覆盖全局 .skill-page：撑满内容区，内边距由内容区统一提供 */
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 0;
  background-color: transparent;
}

.page-header {
  margin-bottom: 30px;
  text-align: center;
}

.page-header h2 {
  margin-bottom: 10px;
  color: #303133;
}

.page-header p {
  color: #606266;
  font-size: 14px;
}
</style>
